import React, { useState, useMemo } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { X } from "react-bootstrap-icons";
import { useFormik } from "formik";
import * as Yup from "yup";
import { PencilSquare, Eye, Trash } from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";
import { IconButton, MenuItem } from "@mui/material";

const validationSchema = Yup.object({
  name: Yup.string().min(2).max(25).required("Please enter your name"),
  category: Yup.string().min(2).max(25).required("Please enter your category"),
  price: Yup.number().required("Please enter your price"),
  description: Yup.string()
    .min(10)
    .max(255)
    .required("Please enter a description"),
});

const Example = () => {
  const [modalData, setModalData] = useState({
    show: false,
    formData: {
      name: "",
      category: "",
      price: "",
      description: "",
    },
    isEditMode: false,
  });

  const [tableData, setTableData] = useState([]);

  const uniqueIdGenerator = () => uuidv4();

  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Product Name",
        size: 150,
      },
      {
        accessorKey: "category",
        header: "Category",
        size: 150,
      },
      {
        accessorKey: "price",
        header: "Price",
        size: 150,
      },
      {
        accessorKey: "description",
        header: "Description",
        size: 150,
      },
    ],
    []
  );

  // ...

  const handleEdit = (data) => {
    setModalData({
      show: true,
      formData: { ...data },
      isEditMode: true,
    });
  };

  const handleView = (data) => {
    console.log("View clicked", data);
  };

  const handleDelete = (id) => {
    const updatedData = tableData.filter((item) => item.id !== id);
    setTableData(updatedData);
  };
  const handleClose = () => {
    setModalData((prevData) => ({
      ...prevData,
      show: false,
    }));
  };

  const handleFormSubmit = () => {
    handleSubmit();
    const formValues = values;
    if (!errors || Object.keys(errors).length === 0) {
      if (modalData.isEditMode) {
        const updatedData = tableData.map((item) =>
          item.id === modalData.formData.id ? { ...item, ...formValues } : item
        );
        setTableData(updatedData);
      } else {
        setTableData((prevData) => [
          ...prevData,
          {
            id: uniqueIdGenerator(),
            ...formValues,
            edit: (
              <Button variant="link" onClick={() => handleEdit(formValues)}>
                <PencilSquare />
              </Button>
            ),
            view: (
              <Button variant="link" onClick={() => handleView(formValues)}>
                <Eye />
              </Button>
            ),
            delete: (
              <Button
                variant="link"
                onClick={() => handleDelete(formValues.id)}
              >
                <Trash />
              </Button>
            ),
          },
        ]);
      }

      handleClose();
    }
  };

  const { values, errors, touched, handleBlur, handleSubmit, handleChange } =
    useFormik({
      initialValues: modalData.formData,
      validationSchema: validationSchema,
      onSubmit: () => {},
    });
  const table = useMaterialReactTable({
    columns,
    data: tableData,
    enableRowActions: true,
    positionActionsColumn: "last",
    renderRowActions: ({ row, table }) => [
      <>
        <div className="d-flex">
          <MenuItem key="edit" onClick={() => handleEdit(row.original)}>
            <PencilSquare />
          </MenuItem>
          ,
          <MenuItem key="view" onClick={() => handleView(row.original)}>
            <Eye />
          </MenuItem>
          ,
          <MenuItem key="delete" onClick={() => handleDelete(row.original.id)}>
            <Trash />
          </MenuItem>
        </div>
      </>,
    ],
  });
  return (
    <>
      <div className="app-content content">
        <div className="content-wrapper">
          <div className="content-header row"></div>
          <div className="content-body">
          <div className="add-product">
            <div className="mb-2">
               <Button variant="primary"
               style={{marginTop:'-20px'}}
              //  className="on-click-btn"
               onClick={() => {
                setModalData({
                  formData: {
                    name: "",
                    category: "",
                    price: "",
                  },
                  isEditMode: false,
                  show: true,
                });
              }}
              >
                  Add Product +
               </Button>
             </div>
            
            </div>
          
            <MaterialReactTable
              table={table}
              // render={({ rows, prepareRow }) => (
              //   <table className="table">
              //     <thead>
              //       <tr>
              //         {table.headerGroups.map((headerGroup) => (
              //           <th {...headerGroup.getHeaderGroupProps()}>
              //             {headerGroup.headers.map((column) => (
              //               <span {...column.getHeaderProps()}>
              //                 {column.render("Header")}
              //               </span>
              //             ))}
              //           </th>
              //         ))}
              //       </tr>
              //     </thead>
              //     <tbody {...table.getTableBodyProps()}>
              //       {rows.map((row) => {
              //         prepareRow(row);
              //         return (
              //           <tr {...row.getRowProps()}>
              //             {row.cells.map((cell) => (
              //               <td {...cell.getCellProps()}>
              //                 {cell.column.accessorKey === "edit" ? (
              //                   <Button
              //                     variant="link"
              //                     onClick={() => handleEdit(row.original)}
              //                   >
              //                     <PencilSquare />
              //                   </Button>
              //                 ) : cell.column.accessorKey === "view" ? (
              //                   <Button
              //                     variant="link"
              //                     onClick={() => handleView(row.original)}
              //                   >
              //                     <Eye />
              //                   </Button>
              //                 ) : cell.column.accessorKey === "delete" ? (
              //                   <Button
              //                     variant="link"
              //                     onClick={() => handleDelete(row.original.id)}
              //                   >
              //                     <Trash />
              //                   </Button>
              //                 ) : (
              //                   cell.render("Cell")
              //                 )}
              //               </td>
              //             ))}
              //           </tr>
              //         );
              //       })}
              //     </tbody>
              //   </table>
              // )}
            />
          </div>
        </div>
      </div>
      <Modal show={modalData.show} onHide={handleClose}>
        <Modal.Header style={{ backgroundColor: "#372f2f", color: "white" }}>
          <Modal.Title><h3 className="text-white">Add your Product</h3></Modal.Title>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <X />
          </IconButton>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
          <div className="d-flex justify-content-center mt-1 justify-content-around"> 
            <Form.Group className="mb-1" controlId="productName">
              <Form.Label>Product Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter product name"
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.name && touched.name ? (
                <p className="color-change">{errors.name}</p>
              ) : null}
            </Form.Group>
            <Form.Group className="mb-1" controlId="productCategory">
              <Form.Label>Category</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter category"
                name="category"
                value={values.category}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.category && touched.category ? (
                <p className="color-change">{errors.category}</p>
              ) : null}
            </Form.Group>
            </div>
            {/* <div className="d-flex justify-content-center mt-1 justify-content-around">  */}
         <div className="container px-2">
            <Form.Group className="mb-1" controlId="productPrice">
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter price"
                name="price"
                value={values.price}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.price && touched.price ? (
                <p className="color-change">{errors.price}</p>
              ) : null}
            </Form.Group>
            </div>
            <div className="container px-2">
            <Form.Group className="mb-1" controlId="productDescription">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter description"
                name="description"
                value={values.description}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.description && touched.description ? (
                <p className="color-change">{errors.description}</p>
              ) : null}
            </Form.Group>
            </div>
            {/* </div> */}
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#372f2f"}}>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleFormSubmit}>
            Add Product
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Example;
